import React from 'react';
import { useQuery } from '@tanstack/react-query';
import api from '../services/api';
import { getFileUrl } from '../utils/fileUtils';
import AnimatedSection from '../components/AnimatedSection';
import Breadcrumbs from '../components/Breadcrumbs';
import './Historia.css';
import '../styles/force-center.css';
import '../styles/EMERGENCY-CENTER-FIX.css';

const Historia = () => {
  const { data, isLoading, isError } = useQuery({
    queryKey: ['secciones-paginas', 'historia'],
    queryFn: async () => {
      const res = await api.get('/secciones-paginas/historia');
      return res.data;
    },
    retry: false,
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000,
  });

  if (isLoading) return <div className="loading">Cargando historia...</div>;
  if (isError || !data) return <div className="loading">No se pudo cargar la historia.</div>;

  const imagenes = Array.isArray(data.imagenes) ? data.imagenes : [];
  const videoUrl = typeof data.video_url === 'string' ? data.video_url.trim() : '';

  const toYoutubeEmbed = (url) => {
    if (!url) return null;
    const u = url.trim();
    const match = u.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([A-Za-z0-9_-]{6,})/);
    const id = match ? match[1] : null;
    return id ? `https://www.youtube.com/embed/${id}` : null;
  };

  const youtubeEmbed = toYoutubeEmbed(videoUrl);

  return (
    <div className="historia-page">
      <Breadcrumbs />
      <AnimatedSection className="section historia-hero" animationType="fadeIn">
        <div className="container">
          <h1 className="page-title">{data.titulo || 'Historia'}</h1>
          {data.resumen && <p className="page-subtitle">{data.resumen}</p>}
        </div>
      </AnimatedSection>

      {/* Contenido Histórico Principal */}
      <AnimatedSection className="section historia-contenido" animationType="fadeInUp">
        <div className="container">
          <div className="historia-texto-principal">
            {imagenes.length > 0 && (
              <div className="historia-media">
                <div className="historia-images-grid" aria-label="Imágenes de la historia">
                  {imagenes.map((img, idx) => (
                    <img
                      key={`${img}-${idx}`}
                      src={getFileUrl(img)}
                      alt=""
                      loading="lazy"
                    />
                  ))}
                </div>
              </div>
            )}

            {youtubeEmbed && (
              <div className="historia-media">
                <div className="historia-video-embed">
                  <iframe
                    src={youtubeEmbed}
                    title="Video"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  />
                </div>
              </div>
            )}

            <div
              className="historia-html"
              dangerouslySetInnerHTML={{ __html: data.contenido || '' }}
            />
          </div>
        </div>
      </AnimatedSection>
    </div>
  );
};

export default Historia;



